import styled from "@emotion/styled";
import assertNever from "assert-never";
import React from "react";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { AppCard } from "./Generic/AppCard";
import { GoogleDocsViewer } from "./GoogleDocsViewer";
import { BoxShimmer } from "./Shimmer";

interface Props {
  url: string;
}

const padding = 32;
const a4AspectRatio = 1.414;

function PdfViewer(props: Props) {
  const { width: windowWidth } = useWindowDimensions();

  const [state, setState] = React.useState<"loading" | "loaded" | "error">("loading");

  const width = windowWidth - padding * 2;
  const height = width * a4AspectRatio;

  const handleDocumentLoadSuccess = () => {
    setState("loaded");
  };

  const handleDocumentLoadError = () => {
    setState("error");
  };

  switch (state) {
    case "error":
      return (
        <AppCard color="danger">
          <p style={{ padding: "0 16px" }}>Failed to load document</p>
        </AppCard>
      );

    case "loading":
    case "loaded":
      return (
        <>
          {state === "loading" ? <BoxShimmer width={width} height={height} /> : null}
          <Container height={height}>
            <GoogleDocsViewer
              documentUrl={props.url}
              onLoad={handleDocumentLoadSuccess}
              onError={handleDocumentLoadError}
            />
          </Container>
        </>
      );

    default:
      assertNever(state);
  }
}

const Container = styled.div<{ height: number }>`
  height: ${({ height }) => height}px;

  img {
    width: 100%;
  }

  iframe {
    height: 100%;
    width: 100%;
    border: none;
  }
`;

export default PdfViewer;
